import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";

function NewsletterThirtyFour() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter July 2025
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            UK Releases Draft Sustainability Standards to Drive Rigorous Climate
            and ESG Disclosures. .
          </title>
          <meta
            name="description"
            content="The UK government has published draft sustainability reporting standards designed to elevate the quality and consistency of corporate ESG disclosures."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          UK Releases Draft Sustainability Standards to Drive Rigorous Climate
          and ESG Disclosures.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/july_2025_1.webp")}
            alt="UK Releases Draft Sustainability Standards to Drive Rigorous Climate and ESG Disclosures."
            loading="lazy"
          />
        </figure>
        <p>
          The UK government has published draft sustainability reporting
          standards designed to elevate the quality and consistency of corporate
          ESG disclosures. The UK Sustainability Reporting Standards (UK SRS) S1
          and S2, developed from the IFRS Sustainability Disclosure Standards,
          aim to align corporate reporting with the UK’s net-zero ambitions
          while meeting the growing demand for transparent, decision-useful
          information.
        </p>
        <p>
          UK SRS S1 sets out requirements for companies to disclose material
          sustainability-related risks and opportunities beyond climate. This
          includes impacts related to biodiversity, workforce, community
          relations, and resource use. Organisations must explain how these
          factors affect their strategy, governance, and future cash flows,
          promoting a comprehensive understanding of sustainability performance.
          The standard also requires clear descriptions of processes for
          identifying and managing these risks across the value chain.
        </p>
        <p>
          UK SRS S2 mandates more detailed climate-related disclosures. It
          obliges companies to report on greenhouse gas emissions, climate
          resilience assessments, transition plans, and the financial
          implications of climate risks. These disclosures must cover short-,
          medium-, and long-term horizons, enabling investors to assess how
          climate change may affect enterprise value.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Companies should proactively assemble ESG foresight teams to
            anticipate emerging sustainability risks, embedding forward-looking
            scenario modelling into strategic planning. Developing agile digital
            tools for real-time data capture and cultivating sustainability
            literacy at the board level, will transform regulatory compliance
            into strategic resilience and competitive positioning ahead of
            formal reporting requirements.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Singapore Issues Comprehensive Blueprint to Strengthen Carbon Markets.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/images/july_2025_2.webp")}
              alt="Singapore Issues Comprehensive Blueprint to Strengthen Carbon Markets."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          Singapore has introduced a detailed framework to enhance the
          credibility and transparency of voluntary carbon markets. Developed by
          the National Climate Change Secretariat, Ministry of Trade and
          Industry, Enterprise Singapore, and the Singapore Sustainable Finance
          Association, the guidance incorporates international standards,
          including the Paris Agreement’s Article 6 and the Core Carbon
          Principles of the Integrity Council for the Voluntary Carbon Market.
          This initiative responds to global concerns over fragmented quality
          standards, opaque disclosures, and the risk of greenwashing that have
          hindered confidence in carbon credit use.
        </p>
        <p>
          The framework sets out seven principles to ensure environmental
          integrity: additionality, permanence, no leakage, verified
          quantification, no double counting, strong governance, and safeguards
          against social or environmental harm. Companies are required to
          prioritise emissions reductions within their operations before using
          credits to meet climate goals. Risk management tools such as credit
          ratings, insurance, and independent labels are encouraged to address
          quality and reputational risks in offset strategies.
        </p>
        <p>
          New disclosure rules mandate clear reporting on credit types, project
          origins, registries, and retirement status. Singapore’s approach
          allows eligible credits to offset part of carbon tax obligations and
          supports market growth through grants, measurement and verification
          services, and regional capacity building. The measures aim to build
          trust in carbon markets and reinforce decarbonisation commitments in
          Southeast Asia’s evolving climate finance landscape.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The framework will compel companies to rethink carbon credits as
            dynamic assets rather than static offsets. Firms should cultivate
            internal carbon intelligence capabilities, prototype decentralised
            verification models, and explore cross-border carbon alliances.
            Integrating predictive analytics and experimenting with tokenised
            credit platforms can unlock deeper transparency and redefine climate
            credibility. Embracing scenario planning that tests multiple
            regulatory futures will help firms build resilience, while forging
            unconventional partnerships with technology providers and ecosystem
            developers can surface new opportunities for differentiation and
            value creation.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Australia Introduces Sustainable Finance Taxonomy to Guide
          Climate-Aligned Investment.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/july_2025_3.webp")}
            alt="Australia Introduces Sustainable Finance Taxonomy to Guide Climate-Aligned Investment."
            loading="lazy"
          />
        </figure>
        <p>
          Australia has released its first Sustainable Finance Taxonomy, a
          detailed framework designed to direct capital toward activities that
          support the country’s commitment to achieve net zero greenhouse gas
          emissions by 2050. Developed in partnership between the Australian
          Sustainable Finance Institute and government agencies, the taxonomy
          provides definitions and criteria for what qualifies as a green or
          transition activity. It focuses on six sectors regarded as critical to
          decarbonisation: energy, transport, agriculture, construction,
          manufacturing, and mining. Each sector is covered by technical
          screening criteria that set clear emissions thresholds consistent with
          pathways outlined in the International Energy Agency’s Net Zero
          scenario and adapted for Australian conditions.
        </p>
        <p>
          To ensure credibility and prevent greenwashing, the taxonomy
          incorporates Do No Significant Harm provisions. These standards
          require that eligible activities avoid causing material negative
          impacts on biodiversity, ecosystems, and water resources. In addition,
          Minimum Social Safeguards ensure investments respect human rights and
          comply with recognised labour and community protections. By combining
          environmental and social criteria, the framework aims to build
          investor confidence and improve the transparency of sustainable
          finance markets.
        </p>
        <p>
          The taxonomy forms a core element of the Australian Government’s
          Sustainable Finance Roadmap, which also includes the introduction of
          sovereign green bonds, mandatory climate-related disclosures starting
          from 2025, and the development of labelling standards for sustainable
          investment products. Although use of the taxonomy will be voluntary in
          the initial phase, it is expected to serve as a reference for
          financial institutions, companies, and regulators when assessing the
          alignment of investments with Australia’s climate goals. It is also
          intended to support more consistent disclosures and inform transition
          plans across the economy.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The taxonomy encourages deeper integration of climate goals into
            financial strategies, prompting investors to reassess risk,
            opportunity, and accountability. It underscores the importance of
            tailored decarbonisation pathways for emissions-intensive industries
            rather than exclusion. Over time, transparent criteria will likely
            become a baseline expectation, reshaping how companies demonstrate
            progress and secure capital credibility worldwide.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Norway Sets Target to Cut Emissions by 70 to 75 % by 2035.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/july_2025_4.webp")}
            alt="Norway Sets Target to Cut Emissions by 70 to 75 %  by 2035."
            loading="lazy"
          />
        </figure>
        <p>
          Norway has announced a plan to reduce greenhouse gas emissions by 70
          to 75 percent by 2035 compared to 1990 levels. This target is part of
          the country’s commitments under the Paris Agreement and is established
          in national law through the Norwegian Climate Change Act. It builds on
          Norway’s earlier pledge to reduce emissions by at least 55 percent by
          2030 and reflects findings from the Intergovernmental Panel on Climate
          Change, which has stressed the urgency of reducing emissions to limit
          global warming.
        </p>
        <p>
          To meet this goal, Norway will rely on a broad mix of policies. Carbon
          pricing through taxes and participation in the emissions trading
          system will remain key tools. Regulations will set standards for
          energy, transport, and industrial activity. The government also plans
          to invest in technologies that capture and store carbon and to
          encourage research and development of low-emission solutions.
          Cooperation with the European Union will play an important role, and
          Norway may use internationally transferred mitigation outcomes if
          domestic measures are not enough.
        </p>
        <p>
          The target covers emissions from all major sectors, including energy,
          manufacturing, agriculture, waste, and land use. While methods for
          calculating emissions and removals from forestry are still being
          finalized, the government has stated that any adjustments will not
          reduce the ambition of the overall plan. Progress will be reported to
          Parliament each year, ensuring transparency and public accountability.
          The government has committed to updating its strategies as new
          scientific data and international agreements emerge.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Supporting a fair transition is a key part of Norway’s approach. A
            council has been established to help manage the social and economic
            impacts of climate policies, bringing together representatives from
            labour organisations, employers, and other stakeholders. While
            short-term costs may rise, the shift can strengthen energy security,
            drive innovation, and create specialised export markets in carbon
            management. Economic resilience will depend on proactive workforce
            transition strategies.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          SEBI Unveils Framework to Expand ESG Debt Securities Beyond Green
          Bonds.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/images/july_2025_5.webp")}
            alt="SEBI Unveils Framework to Expand ESG Debt Securities Beyond Green Bonds."
            loading="lazy"
          />
        </figure>

        <p>
          India’s securities regulator has introduced a comprehensive framework
          to govern ESG-labelled debt securities beyond traditional green bonds.
          This move aims to deepen the country’s sustainable finance ecosystem
          and strengthen investor confidence amid rising global scrutiny of ESG
          disclosures.
        </p>
        <p>
          The new guidelines define clear categories for environmental, social,
          and sustainability bonds. Issuers are required to disclose precise
          use-of-proceeds statements and establish robust processes to track
          funds. Enhanced transparency measures include mandatory annual impact
          reports and external reviews to counter risks of greenwashing.
        </p>
        <p>
          This framework responds to the surge in ESG debt issuance worldwide,
          which surpassed $1 trillion in 2023, reflecting institutional
          investors’ appetite for credible sustainability-linked instruments.
          The initiative aligns India’s capital markets more closely with
          international standards like the ICMA’s Principles and the EU Green
          Bond Standard, while addressing domestic priorities such as affordable
          housing, renewable energy, and gender equality.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            By expanding ESG debt beyond green financing, India is positioning
            itself as a regional leader in sustainable capital mobilisation. The
            framework balances flexibility and accountability, encouraging
            corporates to innovate while ensuring that investors can assess
            claims rigorously. These measures will likely accelerate capital
            flows into projects with measurable social and environmental
            benefits.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default NewsletterThirtyFour;
